<template>
  <v-container fluid>
    <div v-if="loading">
      <div class="mb-3">
        <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
      </div>
      <v-row>
        <v-col cols="12" sm="6" md="4" lg="3" xl="2" v-for="index in 30" :key="index">
          <v-card>
            <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <v-row align="center" no-gutters justify="space-between">
        <div class="text-h1 mb-4">
          Status das Usinas
        </div>
        <div class="filtros">
          <v-row align="center" justify="end" no-gutters>
            <v-form @submit.prevent="applyFilter()">
              <v-text-field
                clearable
                hide-details=""
                clear-icon="close"
                v-model="search"
                outlined
                label="Busca"
                @click:clear="limparBusca()"
              ></v-text-field>
            </v-form>
            <v-autocomplete
              class="ml-3"
              v-if="nivelUsuarioApelido === 'M'"
              :menu-props="{ offsetY: true}"
              :items="distribuidores"
              label="Distribuidor"
              append-icon="expand_more"
              v-model="distribuidor"
              hide-details=""
              :loading="loading || loadingDistribuidores"
              :disabled="loading || loadingDistribuidores"
              outlined
              @click:clear="() => {
                this.page = 1
                this.applyFilter()
              }"
              clearable
              clear-icon="close"
              @change="() => {
                this.page = 1
                this.applyFilter()
              }"
            ></v-autocomplete>
            <v-autocomplete
              v-if="nivelUsuarioApelido === 'M' || nivelUsuarioApelido === 'D'"
              :menu-props="{ offsetY: true}"
              class="ml-3"
              :items="integradores"
              label="Integrador"
              append-icon="expand_more"
              v-model="integrador"
              hide-details=""
              :loading="loading || loadingIntegradores"
              :disabled="loading || loadingIntegradores"
              outlined
              @click:clear="() => {
                this.page = 1
                this.applyFilter()
              }"
              clearable
              clear-icon="close"
              @change="() => {
                this.page = 1
                this.applyFilter()
              }"
            ></v-autocomplete>
            <v-autocomplete
              v-if="categoriasUtilizadas.length"
              :menu-props="{ offsetY: true}"
              class="ml-3"
              :items="categoriasUtilizadas"
              label="Categorias"
              append-icon="expand_more"
              v-model="categoria"
              hide-details=""
              :loading="loading || loadingCategorias"
              :disabled="loading || loadingCategorias"
              outlined
              @click:clear="() => {
                this.page = 1
                this.applyFilter()
              }"
              clearable
              clear-icon="close"
              @change="() => {
                this.page = 1
                this.applyFilter()
              }"
            ></v-autocomplete>
            <div class="ml-3 cursor-pointer" v-for="(item, index) in statusItens" :key="index" @click="setStatus(item, index)">
              <v-btn
                :dark="item.elevation"
                :outlined="!item.elevation"
                :class="
                  item.text === 'Online' && item.elevation ? 'bg-green' :
                  item.text === 'Online' && !item.elevation ? 'text-green' :
                  item.text === 'Offline' && item.elevation ? 'bg-red' :
                  item.text === 'Offline' && !item.elevation ? 'text-red' :
                  item.text === 'Alerta' && item.elevation ? 'bg-primary' :
                  item.text === 'Alerta' && !item.elevation ? 'text-primary' :
                  item.text === 'Não definido' && item.elevation ? 'bg-yellow' :
                  item.text === 'Não definido' && !item.elevation ? 'text-yellow' :
                  item.text === 'Sem conexão' && item.elevation ? 'bg-blue' :
                  item.text === 'Sem conexão' && !item.elevation ? 'text-blue' :
                  item.text === 'Sem retorno' && item.elevation ? 'bg-gray' : 'text-gray'
                  "
                >
                {{item.text}}
              </v-btn>
            </div>
          </v-row>
        </div>
      </v-row>
      <v-row v-if="dados && dados.length > 0">
        <v-col cols="12" v-for="(item, index) in categorias" :key="index">
          <v-row v-if="dados.filter(dado => dado.usi_categoria === item).length > 0">
            <v-col cols="12">
              <h2>{{categoryLabels(item)}}</h2>
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" xl="2" v-for="(item, index) in dados.filter(dado => dado.usi_categoria === item)" :key="index">
              <v-card class="h-100 ui-relative item_cards cursor-pointer text-center px-3 py-2" elevation="3"
              :style="item.status.uss_nome === 'Online' ? 'border-right-color: #118F2D' : item.status.uss_nome === 'Offline' ? 'border-right-color: #FF0B0B' : item.status.uss_nome === 'Alerta' ? 'border-right-color: #EC6521' : item.status.uss_nome === 'Não definido' ? 'border-right-color: #F8B518' : item.status.uss_nome === 'Sem conexão' ? 'border-right-color: #4393B6' : item.status.uss_nome === 'Sem retorno' ? 'border-right-color: #8A8A8A' : 'border-right-color: #8A8A8A'" @click="openUsina(item)">
                <div class="text-h3 w-100 mb-1">{{item.usi_nome}}</div>
                <div class="text w-100 mb-3">{{item.usi_cidade}}</div>
                <div class="text w-100 mb-1">Produção Média Diária: ~{{item.producao_dia}} kWh</div>
                <div class="text w-100 mb-3 small">Total: {{item.producao_total}} kWh</div>
                <div class="text w-100 mb-3 text-primary" :class="item.status.uss_nome  === 'Online' ? 'text-green' : item.status.uss_nome  === 'Offline' ? 'text-red' : item.status.uss_nome  === 'Alerta' ? 'text-primary' : item.status.uss_nome  === 'Não definido' ? 'text-yellow' : item.status.uss_nome  === 'Sem conexão' ? 'text-blue' : item.status.uss_nome  === 'Sem retorno' ? 'text-gray' : 'text-gray'">
                  {{item.status.uss_nome}}
                </div>
                <!-- <div class="text w-100 text-yellow" v-else-if="item.status.uss_tipo === 2">
                  {{item.status.uss_nome}}
                </div>
                <div class="text w-100 text-green" v-else-if="item.status.uss_tipo === 1">
                  {{item.status.uss_nome}}
                </div>
                <div class="text w-100 text-gray" v-else>
                  {{item.status.uss_nome}}
                </div> -->
                <v-row justify="end">
                  <v-col cols="auto px-0 mr-3" v-if="item.status.uss_id == 3">
                    <v-btn class="button_fixed">
                      <v-icon color="warning" @click="(event) => openAlertDialog(item, event)">warning_amber</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="auto px-0 mr-3">
                    <v-btn class="button_fixed">
                      <v-icon :color="$vuetify.theme.dark ? 'white' : 'black'">visibility</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="auto px-0 mr-3">
                    <!-- <v-btn class="button_fixed" :color="item.status.uss_nome === 'Online' ? '#118F2D' : item.status.uss_nome === 'Offline' ? '#FF0B0B' : item.status.uss_nome === 'Alerta' ? '#EC6521' : item.status.uss_nome === 'Não definido' ? '#F8B518' : item.status.uss_nome === 'Sem conexão' ? '#4393B6' : item.status.uss_nome === 'Sem retorno' ? '#8A8A8A' : '#8A8A8A'"> -->
                    <v-btn class="button_fixed" @click="(event) => openDialog(item, event)">
                      <v-icon :color="$vuetify.theme.dark ? 'white' : 'black'">edit</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" v-if="total > 1">
          <div class="d-flex justify-end">
            <v-pagination
              v-model="page"
              :length="total"
              :total-visible="11"
              prev-icon="navigate_before"
              next-icon="navigate_next"
              @input="applyFilter()"
              :disabled="loading"
            ></v-pagination>
          </div>
        </v-col>
      </v-row>
      <div v-else>
        <div class="px-2 py-2">
          Nenhum status encontrado.
        </div>
      </div>
    </div>
    <!-- <div class="ui-create">
      <v-btn color="primary" elevation="3" @click="dialogEdit = true" :loading="loading" :disabled="loading">
        <v-icon color="white" x-large>add</v-icon>
      </v-btn>
    </div> -->
    <v-dialog
      v-model="dialogEdit"
      persistent
      max-width="400px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Alterar categoria da usina {{usina.usi_nome}}
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formUsina">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
              <!-- <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="usina.usina"
                :items="['Usina 1', 'Usina 2', 'Usina 3', 'Usina 4']"
                clearable
                clear-icon="close"
                label="Usina*"
                :rules="[rules.required]"
                append-icon="expand_more"
                :loading="salvando"
                :disabled="salvando"
                outlined
              >
              </v-autocomplete> -->
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
               <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="categoriaEdit"
                :items="categorias.map(categoria => categoryLabels(categoria))"
                clearable
                clear-icon="close"
                label="Categoria*"
                :rules="[rules.required]"
                append-icon="expand_more"
                :loading="salvando"
                :disabled="salvando"
                outlined
              >
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="editarCategoria()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogAlertEdit"
      persistent
      max-width="400px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Alertas da usina {{usina.usi_nome}}
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeAlertDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-list v-if="alerts.length">
          <v-list-item
              v-for="alert in alerts"
              :key="alert.title"
              three-line
          >
            <v-list-item-content>
              <v-list-item-title>
                SN: {{alert.title}}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{alert.text}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <div v-if="!alerts.length">
          Não foi possível sincronizar os alertas desta Usina
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@API'
export default {
  data () {
    return {
      search: '',
      loading: true,
      salvando: false,
      dialogEdit: false,
      dialogAlertEdit: false,
      selectedStatus: null,
      elevation: false,
      nivelUsuarioApelido: '',
      integradores: [],
      integradoresCadastro: [],
      integrador: null,
      loadingIntegradores: false,
      loadingDistribuidores: false,
      loadingCategorias: false,
      distribuidor: null,
      distribuidores: [],
      distribuidorAnterior: null,
      categoriasUtilizadas: [],
      categorias: [
        'DEFAULT',
        'MAINTENANCE',
        'OBSERVATION'
      ],
      categoria: '',
      categoriaEdit: '',
      total: 0,
      page: 1,
      options: {},
      rules: {
        required: value => !!value || 'Obrigatório.'
      },
      statusItens: [],
      dados: [],
      alerts: [],
      usina: {
        usi_nome: '',
        uuid_uss_id: ''
      },
      timer: null
    }
  },
  methods: {
    setStatus (item, index) {
      if (this.selectedStatus && this.selectedStatus === item.value) {
        this.selectedStatus = null
        this.statusItens[index].elevation = false
      } else {
        this.statusItens.map(status => {
          if (status.value !== item.value) {
            status.elevation = false
          }
        })
        this.selectedStatus = item.value
        this.statusItens[index].elevation = true
      }
      this.page = 1
      this.applyFilter()
    },
    async loadFunctions () {
      let filters = this.$route.query
      if (filters.distribuidor) this.distribuidor = filters.distribuidor
      if (filters.integrador) this.integrador = filters.integrador
      if (filters.page) this.page = Number(filters.page)
      if (filters.busca) {
        this.search = filters.busca
      }

      await this.getStatus()
      if (filters.status) {
        this.selectedStatus = filters.status
        this.statusItens.map(status => {
          if (status.value === this.selectedStatus) {
            status.elevation = true
          }
        })
      }
      this.getDistribuidores()
      if (this.nivelUsuarioApelido !== 'I') {
        this.getIntegradores(this.distribuidor)
      }
      clearInterval(this.timer)
      this.getUsinasStatus()
      this.statusInterval()
      this.getCategories()
    },
    async getDistribuidores () {
      this.loadingDistribuidores = true
      await Api.get('distribuidores')
        .then(res => {
          var arrayDists = []
          res.data.map(dist => {
            arrayDists.push({
              'text': dist.dis_nome,
              'value': dist.uuid_dis_id
            })
          })
          this.distribuidores = arrayDists
          this.loadingDistribuidores = false
        })
        .catch(err => {
          this.loadingDistribuidores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os distribuidores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getIntegradores (distribuidor = null) {
      this.loadingIntegradores = true
      let url = 'integradores'

      if (distribuidor) {
        url = `integradores/distribuidor/${distribuidor}`
      }
      await Api.get(url)
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            arrayInt.push({
              'text': int.int_nome,
              'value': int.uuid_int_id
            })
          })
          this.integradores = arrayInt
          this.loadingIntegradores = false
        })
        .catch(err => {
          this.loadingIntegradores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    statusInterval () {
      this.timer = setInterval(this.getUsinasStatus, 120000)
    },
    applyFilter () {
      if (this.distribuidorAnterior && this.distribuidor !== this.distribuidorAnterior) {
        this.integrador = ''
      }

      let query = Object.assign({},
        this.page ? { page: this.page } : '',
        this.distribuidor ? { distribuidor: this.distribuidor } : '',
        this.integrador ? { integrador: this.integrador } : '',
        this.selectedStatus ? { status: this.selectedStatus } : '',
        this.search ? { busca: this.search } : ''
      )

      this.$router.replace({name: 'StatusUsinas', query: query}).catch(() => {})
      this.dados = []
      this.distribuidorAnterior = this.distribuidor
      this.getIntegradores(this.distribuidor)
      clearInterval(this.timer)
      this.getUsinasStatus()
      this.statusInterval()
    },
    async getUsinasStatus () {
      this.loading = true
      this.total = 0
      this.dados = []
      let filtro = '?page=' + this.page
      filtro += '&per_page=16'

      if (this.distribuidor) {
        filtro += '&distribuidor=' + this.distribuidor
      }
      if (this.integrador) {
        filtro += '&integrador=' + this.integrador
      }
      if (this.selectedStatus) {
        filtro += '&status=' + this.selectedStatus
      }
      if (this.categoria) {
        filtro += '&categoria=' + this.categoryValues(this.categoria)
      }
      if (this.search) {
        filtro += '&busca=' + this.search
      }

      let url = `usinas/status${filtro}`
      await Api.get(url)
        .then(res => {
          this.dados = res.data.data
          console.log(this.dados)
          this.total = res.data.last_page
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os status das usinas!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getStatus () {
      this.loadingStatus = true
      await Api.get('usinas-status')
        .then(res => {
          var arrayUsi = []
          res.data.map(usi => {
            arrayUsi.push({
              'text': usi.uss_nome,
              'value': usi.uuid_uss_id
            })
          })
          this.statusItens = arrayUsi
          this.loadingStatus = false
        })
        .catch(err => {
          this.loadingUsinas = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os status!',
            color: 'error'
          })
          console.log(err)
        })
    },
    editarStatus () {
      if (!this.$refs.formUsina.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      Api.post('usinas/status/edita', this.usina)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.closeDialog()
          clearInterval(this.timer)
          this.getUsinasStatus()
          this.statusInterval()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    editarCategoria () {
      if (!this.$refs.formUsina.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.usina.usi_categoria = this.categoryValues(this.categoriaEdit)
      this.salvando = true
      Api.post('usinas/categoria/edita', this.usina)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.closeDialog()
          clearInterval(this.timer)
          this.getUsinasStatus()
          this.statusInterval()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    openUsina (item) {
      this.$router.push({ name: 'VisaoGeralInterna', params: { uuid: item.uuid_usi_id } }).catch(() => {})
    },
    openDialog (item, event) {
      if (event) {
        event.stopPropagation()
      }
      this.usina = item
      this.categoriaEdit = this.categoryLabels(this.usina.usi_categoria)
      console.log(this.categoriaEdit)
      this.dialogEdit = true
    },
    closeDialog () {
      this.usina = {
        usi_nome: '',
        uuid_uss_id: ''
      }
      if (this.$refs.formUsina) {
        this.$refs.formUsina.resetValidation()
      }
      this.dialogEdit = false
    },
    openAlertDialog (item, event) {
      if (event) {
        event.stopPropagation()
      }
      this.usina = item
      this.dialogAlertEdit = true

      this.getUsinaAlertas(this.usina.uuid_usi_id)
    },
    closeAlertDialog () {
      this.usina = {
        usi_nome: '',
        uuid_uss_id: ''
      }

      this.dialogAlertEdit = false
    },
    getUsinaAlertas (usinaUuid) {
      Api.get(`inversor-alarme-historico/usina/${usinaUuid}`)
        .then((response) => {
          this.alerts = response.data.map(alerta => ({
            title: alerta.inversor.inv_serial,
            text: alerta.inv_al_his_alarmes
          }))

          this.alerts.forEach(alert => {
            this.getAlertaDescricao(alert.text)
          })
        })
        .catch((error) => {
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar alertas!',
            color: 'error'
          })
        })
    },
    getAlertaDescricao (codes) {
      Api.get(`inversor-alarm/${codes}`)
        .then((response) => {
          const alertIndex = this.alerts.findIndex(alert => alert.text === codes)
          this.alerts[alertIndex].text = ''
          response.data.forEach((alerta, index) => {
            if (index === 0) {
              this.alerts[alertIndex].text += alerta.inv_al_descricao
            } else {
              this.alerts[alertIndex].text += `, ${alerta.inv_al_descricao}`
            }
          })
        })
        .catch((error) => {
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar alertas!',
            color: 'error'
          })
        })
    },
    getCategories () {
      this.loadingCategorias = true
      Api.get('usinas/categorias')
        .then((response) => {
          this.loadingCategorias = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }

          this.categoriasUtilizadas = response.data.map(categoria => this.categoryLabels(categoria.usi_categoria))
        })
        .catch((error) => {
          this.loadingCategorias = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar categorias!',
            color: 'error'
          })
        })
    },
    categoryLabels (category) {
      switch (category) {
        case 'DEFAULT':
          return 'Padrão'
        case 'MAINTENANCE':
          return 'Em manutenção'
        case 'OBSERVATION':
          return 'Em observação'
      }
    },
    categoryValues (category) {
      switch (category) {
        case 'Padrão':
          return 'DEFAULT'
        case 'Em manutenção':
          return 'MAINTENANCE'
        case 'Em observação':
          return 'OBSERVATION'
      }
    },
    updateData () {
      if (JSON.parse(localStorage.getItem('user')) !== null && !this.user) {
        this.user = JSON.parse(localStorage.getItem('user'))
        if (this.user.fk_gru_id_grupo) {
          this.nivelUsuarioApelido = 'M'
        }
        if (this.user.fk_dis_id_distribuidor) {
          this.nivelUsuarioApelido = 'D'
        }
        if (this.user.fk_int_id_integrador) {
          this.nivelUsuarioApelido = 'I'
        }
      }
    }
  },
  updated () {
    this.updateData()
  },
  created () {
    this.updateData()
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.item_cards {
  align-items: center;
  border-right: 12px solid;
  border-radius: 0px!important;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}

>>> .small {
  font-size: 12px !important;
  color: $text;
}
>>> .button_fixed {
  border-radius: 100%;
  // bottom: -2px;
  height: 35px!important;
  min-width: inherit!important;
  // position: absolute;
  // right: -20px;
  width: 35px;
}
.filtros {
  span {
    float: left;
    height: 25px;
    margin-left: 10px;
    width: 25px;
  }
  label {
    float: left;
    margin-left: 8px;
    margin-top: 2px;
  }
  @media (max-width: 767px){
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cadastros/StatusUsinas.vue